export default "/_next/static/src/assets/videos/28978261684cd12447cbff1287190620.mp4";